import { Void } from "@pdfking/tfunc"
import { BROWSER_ERROR } from "@pdfking/translations/enum/errors"
import { defineComponent } from "vue"
import messages from "../state/messages"

export default defineComponent({
  methods: {
    initial_action: () => messages().send_error(BROWSER_ERROR),
  },
  mounted() {
    this.initial_action()
  },
  render: Void,
})
